module.exports = __webpack_public_path__ + "img/ic_be_being.94f245ca.svg";